import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/User/Login/Login.vue')
  },
  {
    path: '/LineLogin',
    name: 'LineLogin',
    component: () => import('../views/User/Login/LineLogin.vue')
  },
  {
    path: '/RestPW',
    name: 'RestPW',
    component: () => import('../views/User/ForgetPwd.vue')
  },
  // {
  //   path: '/Register',
  //   name: 'Register',
  //   component: () => import('../views/User/Register.vue')
  // },
  {
    path: '/Register/:id',
    name: 'Register',
    component: () => import('../views/User/Register.vue')
  },
  {
    path: '/Profile',
    name: 'Profile',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/User/Profile.vue')
  },
  {
    path: '/ChangePW',
    name: 'ChangePW',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/User/ChangePwd.vue')
  },
  /** Log */
  {
    path: '/HistoryLog/:id?',
    name: 'HistoryLog',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/User/HistoryLog.vue')
  },
  {
    path: '/UsementLog',
    name: 'UsementLog',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/User/UsementLog.vue')
  },
  {
    path: '/PaymentLog',
    name: 'PaymentLog',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/User/PaymentLog.vue')
  },
  /** Ｍaster */
  {
    path: '/MasterChat',
    name: 'MasterChat',
    component: () => import('../views/User/Master.vue')
  },
  /** Payment */
  {
    path: '/Payment',
    name: 'Payment',
    component: () => import('../views/User/Payment.vue'),
    meta: {requiresAuth: true},
    children: [
      {path: '/', redirect: 'Plan', meta: {requiresAuth: true}},
      {
        path: 'Plan',
        name: 'Plan',
        component: () => import('../views/User/Payment/Plan.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'PlanCart',
        name: 'PlanCart',
        component: () => import('../views/User/Payment/WebUser_ShopCart.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'CheckOut',
        name: 'CheckOut',
        component: () => import('../views/User/Payment/CheckOut.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'Ecpay',
        name: 'Ecpay',
        component: () => import('../views/User/Payment/ECpay.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'OrderResult/:tradeno',
        name: 'OrderResult',
        component: () => import('../views/User/Payment/ECpayOrderResult.vue'),
        meta: {requiresAuth: true},
      },

      {
        path: 'ShopCard',
        name: 'ShopCard',
        meta: {requiresAuth: true}, // 需驗證
        component: () => import('../views/User/Payment/SalesUser_ShopCart.vue'),
      },
      {
        path: 'SalesEcpay',
        name: 'SalesEcpay',
        component: () => import('../views/User/Payment/SalesECpay.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'PayCancel/:trandno/:id',
        name: 'PayCancel',
        component: () => import('../views/User/Payment/PayCancel.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'EBResult/:tradeno',
        name: 'EBResult',
        component: () => import('../views/User/Payment/NBpayOrderResult.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'Contract',
        name: 'Contract',
        component: () => import('../views/User/Payment/SalesContract.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'AgentContract',
        name: 'AgentContract',
        component: () => import('../views/User/Payment/SalesAgentContract.vue'),
        meta: {requiresAuth: true},
      },
      ]
  },
  /** Promotion */
  {
    path: '/Promotion',
    name: 'Promotion',
    meta: {requiresAuth: true},
    component: () => import('../views/User/Promotion.vue')
  },
  /** Analysis Personality */
  {
    path: '/Personality',
    name: 'Personality',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Personality.vue'),
  },
  /** Analysis Allyear */
  {
    path: '/Allyear',
    name: 'Allyear',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Allyear.vue'),
  },
  /** Analysis Client */
  {
    path: '/Client',
    name: 'Client',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Client.vue'),
  },
  {
    path: '/ClientResult/:way',
    name: 'ClientResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/ClientResult.vue'),

  },
  /** Analysis Lover */
  {
    path: '/Lover',
    name: 'Lover',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Lover.vue'),
  },
  {
    path: '/LoverResult',
    name: 'LoverResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/LoverResult.vue'),

  },
  /** Analysis Relativewes */
  {
    path: '/Relativewes',
    name: 'Relativewes',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Relativewes.vue'),
  },
  {
    path: '/ReleativeResult',
    name: 'ReleativeResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/ReleativeResult.vue'),
  },
  /** Analysis Colleague */
  {
    path: '/Colleague',
    name: 'Colleague',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Colleague.vue'),
  },
  {
    path: '/ColleagueResult',
    name: 'ColleagueResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/ColleagueResult.vue'),
  },
  /** Analysis Overall */
  {
    path: '/Overall',
    name: 'Overall',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Overall.vue'),
  },
  {
    path: '/OverallResult',
    name: 'OverallResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/OverallResult.vue'),
  },
  /** Analysis Phone */
  {
    path: '/Phone',
    name: 'Phone',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Phone.vue'),
  },
  {
    path: '/PhoneResult',
    name: 'PhoneResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/PhoneResult.vue'),
  },
  {
    path: '/PhoneVipResult',
    name: 'PhoneVipResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/PhoneVipResult.vue'),
  },
  /** Analysis Phone */
  {
    path: '/Master',
    name: 'Master',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/Master.vue'),
  },
  {
    path: '/MasterResult',
    name: 'MasterResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/MasterResult.vue'),
  },
  {
    path: '/MasterVipResult',
    name: 'MasterVipResult',
    meta: {requiresAuth: true}, // 需驗證
    component: () => import('../views/Analysis/MasterVipResult.vue'),
  },
  /** Sales */
  {
    path: '/Sales',
    name: 'Sales',
    component: () => import('../views/User/Sales.vue'),
    meta: {requiresAuth: true},
    children: [
      {path: '/', redirect: 'Dashboard', meta: {requiresAuth: true}},
      {
        path: 'Dashboard',
        name: 'Dashboard',
        component: () => import('../views/User/Sales/Dashboard.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MyClient',
        name: 'MyClient',
        component: () => import('../views/User/Sales/MyClient.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MyClientNew',
        name: 'MyClientNew',
        component: () => import('../views/User/Sales/MyClient_New.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MySales',
        name: 'MySales',
        component: () => import('../views/User/Sales/MySales.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MySocial',
        name: 'MySocial',
        component: () => import('../views/User/Sales/MySocial.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MyQRcode',
        name: 'MyQRcode',
        component: () => import('../views/User/Sales/MyQRcode.vue'),
        meta: {requiresAuth: true},
      },
      {
        path: 'MySalesInfo',
        name: 'MySalesInfo',
        component: () => import('../views/User/Sales/MySalesInfomation.vue'),
        meta: {requiresAuth: true},
      },


    ]
  },
  /** Sales Register */
  {
    path: '/RegisterHome/:id',
    name: 'RegisterHome',
    component: () => import('../views/User/SalesRegister/RegisterHome.vue'),
    meta: {requiresAuth: false},
    // children: [
    //   { path: '/', redirect: 'RegisterWay',
    //     meta: {requiresAuth: false}},
    //   {
    //     path: 'RegisterWay',
    //     name: 'RegisterWay',
    //     component: () => import('../views/User/SalesRegister/RegisterWay.vue'),
    //     meta: {requiresAuth: false},
    //   },
    // ]
  },
  /** Dev */
  {
    path: '/DevPage',
    name: 'DevPage',
    component: () => import('../views/DevUse/DevPage.vue')
  },
  {path: '*', redirect: '/home'}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
